import { useTranslate } from "@lobby/ocb-intl";
import { Tabs } from "../../../../../shared";
import { Authentication } from "./authentication";
import { UserDataForm } from "./user-data-form";

const THEME = (import.meta as any).env.VITE_THEME;
const IS_2FA_ENABLED = THEME === "bestspins365";

export function Settings() {
  const { $t } = useTranslate();
  return (
    <div className="mobile-only:relative flex h-full min-h-0 flex-col">
      <Tabs
        items={[
          {
            label: $t({ defaultMessage: "My Data" }),
            children: <UserDataForm />,
          },
          {
            label: IS_2FA_ENABLED
              ? $t({ defaultMessage: "Authentication" })
              : $t({ defaultMessage: "Change Password" }),
            children: <Authentication />,
          },
        ]}
      />
    </div>
  );
}
